export default __webpack_public_path__ + "wix-logo-ff.4c315bb2.svg";